import script from "./ynMultipleSelect.vue?vue&type=script&lang=js"
export * from "./ynMultipleSelect.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__